import { render, staticRenderFns } from "./SelectSpeciality.vue?vue&type=template&id=fdd19dd8&scoped=true&"
import script from "./SelectSpeciality.vue?vue&type=script&lang=js&"
export * from "./SelectSpeciality.vue?vue&type=script&lang=js&"
import style0 from "./SelectSpeciality.vue?vue&type=style&index=0&id=fdd19dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd19dd8",
  null
  
)

export default component.exports